import { FormEsasFilledByEnum } from '../../../types/src/services/enum/form-esas-filled-by.enum';

export class FormsOtherHelpers {

    public static mapEsasFilledByToText(filledBy: string): string {
        switch(filledBy) {
            case FormEsasFilledByEnum.PATIENT:
                return 'Pacient';
            case FormEsasFilledByEnum.CAREGIVER:
                return 'Pečující osoba';
            case FormEsasFilledByEnum.MEDIC:
                return 'Zdravotník';
            default:
                return '';
        }
    }
}
